import { Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lifedi-rating-choice',
  templateUrl: './rating-choice.component.html',
  styleUrls: ['./rating-choice.component.scss']
})
export class RatingChoiceComponent implements OnInit {

  @Input() measureForm: FormGroup;
  @Input() ratingChoice;
  @Input() isAutoNumber: boolean = true;
  @Input() questionNumber: number;
  @Input() type: string;
  @Input() font: string;
  @Output() progressVal = new EventEmitter<Number>();

  countProgress: number = 1;
  countAnswers: number = 0;

  ratingChoiceForm: FormGroup
  detailLength: number = 0;

  value: number;
  options: Options = {
    showTicksValues: false,
    stepsArray: [
    ],
    showTicks: true
  };
  valDefault: number;
  choiceLength: number;
  done: boolean = false;

  constructor(
    private fb: FormBuilder,
  ) { }

  get answers(): FormArray {
    if (this.measureForm) {
      return this.measureForm.controls['DATA'] as FormArray;
    }
  }

  ngOnInit(): void {

    if (this.type === 'measure') {
      this.ratingChoiceForm = this.fb.group({
        ID: [this.ratingChoice.ID, Validators.required],
        ANSWER: ['', Validators.required]
      })
      this.answers.push(this.ratingChoiceForm);
    } else if (this.type === 'research') {
      this.ratingChoiceForm = this.fb.group({
        ID: [this.ratingChoice.ID, Validators.required],
        ANSWER: ['']
      })
      this.answers.push(this.ratingChoiceForm);
    } else {
      this.done = true;
    }


    if (this.ratingChoice) {
      this.valDefault = parseInt(this.ratingChoice.VALUE[0].default);
      this.choiceLength = parseInt(this.ratingChoice.VALUE[0].length);

      this.ratingChoice.VALUE[0].choices.forEach(e => {
        let num: number = 0;
        // console.log(e.choice_detail);

        for (let i = 0; i < e.choice_detail.length; i++) {
          if (e.choice_detail.charCodeAt(i) < 3655 || e.choice_detail.charCodeAt(i) > 3663) {
            if (e.choice_detail.charCodeAt(i) < 3635 || e.choice_detail.charCodeAt(i) > 3643) {
              if (e.choice_detail.charCodeAt(i) !== 3633) {
                // console.log(e.choice_detail.charCodeAt(i));
                num = num + 1;
                // this.detailLength = num;
              }
            }
          }
        }  
        if (num > this.detailLength) {
          this.detailLength = num;
        } else {
          this.detailLength;
        }      
      });
      

      // console.log(this.detailLength);

      if (this.choiceLength > 7) {
        if (this.valDefault === 1) {
          for (let i = 0; i < this.choiceLength; i++) {

            if (i === 0) {
              this.options.stepsArray.push({
                value: i + 1,
                legend: this.ratingChoice.VALUE[0].choices[0].choice_detail
              })
            }
            else if (i === (this.choiceLength - 1)) {
              this.options.stepsArray.push({
                value: i + 1,
                legend: this.ratingChoice.VALUE[0].choices[1].choice_detail
              })
            } else {
              this.options.stepsArray.push({
                value: i + 1,
              })
            }

          }
        }
        else if (this.valDefault === 0) {
          for (let i = 0; i < this.choiceLength; i++) {
            if (i === 0) {
              this.options.stepsArray.push({
                value: i,
                legend: this.ratingChoice.VALUE[0].choices[0].choice_detail
              })
            }
            else if (i === (this.choiceLength - 1)) {
              this.options.stepsArray.push({
                value: i,
                legend: this.ratingChoice.VALUE[0].choices[1].choice_detail
              })
            } else {
              this.options.stepsArray.push({
                value: i,
              })
            }
          }
        }

      } else {

        if (this.valDefault === 1) {
          for (let i = 0; i < this.ratingChoice.VALUE[0].choices.length; i++) {
            const e = this.ratingChoice.VALUE[0].choices[i];

            this.options.stepsArray.push({
              value: i + 1,
              legend: e.choice_detail
            })
          }
        } else if (this.valDefault === 0) {
          for (let i = 0; i < this.ratingChoice.VALUE[0].choices.length; i++) {
            const e = this.ratingChoice.VALUE[0].choices[i];

            this.options.stepsArray.push({
              value: i,
              legend: e.choice_detail
            })
          }
        }
      }

      // // console.log(this.options.stepsArray)
    }
  }

  addValue(value) {
    this.ratingChoiceForm.patchValue({
      ANSWER: value
    })
    this.ratingChoiceForm.get('ANSWER').updateValueAndValidity();
    this.progress(this.ratingChoiceForm);
  }

  progress(form) {

    if (form.status === 'VALID') {
      this.done = true;
    } else if (form.status === 'INVALID') {
      this.done = false;
    }

    // // console.log(form.status);
    if (form.status === 'VALID' && this.countAnswers === 0) {
      this.countAnswers = 1;

      if (this.countAnswers === 1) {
        this.countProgress = 2;
        this.progressVal.emit(this.countProgress);
      }

    } else if (form.status === 'INVALID' && this.countProgress === 2) {
      this.countProgress = 0;
      this.countAnswers = 0;
      this.progressVal.emit(this.countProgress);
    }
    // // console.log(this.countProgress);
    // // console.log(this.countAnswers);
  }

}
